import { toId } from '@componentdriven/csf';

export function targetStoryKind(
  kindName: string
): (storyName: string) => string {
  return (storyName: string) => `iframe.html?id=${toId(kindName, storyName)}`;
}
